import { useMaybeGetSpace } from "@/data/api";
import React from "react";
import { PartnerConfig } from "@/offering/partner_config";
import { useParams } from "react-router-dom";
import { TemplateOfferingConfirmOrderDailyOffice } from "./template_offering_confirm_order_daily_office";
import { TemplateOfferingConfirmOrderEvent } from "./template_offering_confirm_order_event";
import { TemplateOfferingConfirmOrderMeetingRoomV2 } from "./template_offering_confirm_order_meeting_room_v2";
import {
  OrderableType,
  OrderItem,
  OrderItemDayPass,
  OrderItemHourlyPass,
  OrderItemMultiPass,
  useOrderQuery,
} from "@/offering/api";

interface TemplateOfferingConfirmOrderRoomGalleryProps {
  partnerConfig: PartnerConfig;
}

interface TemplateOfferingConfirmOrderRoomGalleryPageParams {
  spaceID: string;
  orderID: string;
}

export function isNotOrderItemMembership(
  orderItem: OrderItem
): orderItem is OrderItemDayPass | OrderItemHourlyPass | OrderItemMultiPass {
  return orderItem.type !== OrderableType.Membership;
}

export const TemplateOfferingConfirmOrderRoomGallery = (
  props: TemplateOfferingConfirmOrderRoomGalleryProps
) => {
  const { partnerConfig } = props;

  const { orderID } =
    useParams<TemplateOfferingConfirmOrderRoomGalleryPageParams>();

  const order = useOrderQuery(orderID);
  const orderItemWithSpaceId = order?.orderItems.find(isNotOrderItemMembership);

  const spaceID = orderItemWithSpaceId?.details.spaceID || null;

  const space = useMaybeGetSpace(spaceID);

  if (!space) {
    return null;
  }

  return space.spaceType === "meeting_room" ? (
    <TemplateOfferingConfirmOrderMeetingRoomV2 partnerConfig={partnerConfig} />
  ) : space.spaceType === "event_space" ? (
    <TemplateOfferingConfirmOrderEvent partnerConfig={partnerConfig} />
  ) : space.spaceType === "private_office" ? (
    <TemplateOfferingConfirmOrderDailyOffice partnerConfig={partnerConfig} />
  ) : null;
};
